import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {IListFilters} from '../shared/SearchFilterBar'
import {IApplicationModel, IApplicationUpdateRequest} from './ApplicationModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const APPLICATION_URL = `${API_URL}api/v1/apply-job/`

/** Boş filtreler isteğe eklenmez */
export const filterParams = (filters: Partial<IListFilters>) =>
  Object.fromEntries(Object.entries(filters).filter(([, value]) => !!value))

/** Gelen başvurular; en yeni başvuru üstte */
export function searchApplications(
  filters: Partial<IListFilters>,
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IApplicationModel>>>> {
  return corporateApi.get(`${APPLICATION_URL}search`, {
    params: {...filterParams(filters), page, size, sort: 'createdDate,desc'},
  })
}

export function getApplication(id: string): Promise<AxiosResponse<ApiResponse<IApplicationModel>>> {
  return corporateApi.get(`${APPLICATION_URL}getById/${id}`)
}

export function updateApplication(
  id: string,
  request: IApplicationUpdateRequest
): Promise<AxiosResponse<ApiResponse<IApplicationModel>>> {
  return corporateApi.patch(`${APPLICATION_URL}update/${id}`, request)
}

export function deleteApplication(id: string) {
  return corporateApi.delete(`${APPLICATION_URL}delete/${id}`)
}

/** Aday takip kaydı oluşturur; aday sürecin ilk adımına konur */
export function startApplicationProcess(id: string) {
  return corporateApi.post(`${APPLICATION_URL}startProcess/${id}`)
}
